module.exports = __webpack_public_path__ + "fd960dc05c2579fc09bf8e759a64c44d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_3_2023_chart.png
// module id = 1684
// module chunks = 0